import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import Icon from '../../../../components/Icon';
import dialogs from '../../../../dialogs';
import currency from '../../../../utils/currency';
import styles from './Activity.module.scss';

const STATUS = {

  // Missing
  '_M': {
    action: {
      className: styles._missing,
      disabled: false,
      label: 'Start',
    },
  },

  // Assigned
  'A': {
    action: {
      className: styles.assigned,
      disabled: false,
      label: 'Start',
    },
  },

  // Submitted
  'S': {
    action: {
      className: styles.submitted,
      disabled: false,
      label: 'Edit',
    },
  },

  // Accepted
  'D': {
    action: {
      className: styles.accepted,
      disabled: true,
      label: 'Completed',
    },
  },

  // Rejected
  'R': {
    action: {
      className: styles.rejected,
      disabled: false,
      label: 'Try Again',
    },
  },
};

const ActivityGroup = ({ campaign, group, handle }) => {

  const status = group.user.status || '_M';

  /*
   * dialog
   */

  const { dialog, setDialog } = dialogs.utils.useDialog();
  const [ dialogShow, setDialogShow ] = useState();

  useEffect(() => {

    const [ kind_1, text_1, kind_2 , text_2, ...rest ] = (dialog || '').split(' ');

    const value = (
      kind_1 === 'campaign' &&
      text_1 === (campaign.id + '') &&
      kind_2 === 'group' &&
      text_2 === (group.id + '') &&
      rest.length === 0
    );

    if (value && status === 'D') {
      setDialog();
      return;
    }

    setDialogShow(value);

  }, [dialog, setDialog, campaign, group, status]);

  /*
   * content
   */

  const firstAction = group.activities?.[0]?.action;
  const Dialog = firstAction === 'url_submit_plus'
    ? dialogs.campaigns.activities.GroupUrlSubmitPlus
    : dialogs.campaigns.activities.GroupUrlSubmit;

  const total = group.activities ? group.activities.length : 0;
  const complete = group.activities
    ? group.activities.filter(
        a => a.user.status === 'S' || a.user.status === 'D'
      ).length
    : 0;
  const allComplete = total > 0 && complete === total;
  const rejectedCount = group.activities
    ? group.activities.filter(a => a.user.status === 'R').length
    : 0;

  let buttonLabel, buttonClassName;
  if (!group.user.enable) {
    buttonLabel = 'Not Yet';
    buttonClassName = styles._missing;
  } else if (rejectedCount > 0) {
    buttonLabel = 'Try Again';
    buttonClassName = styles.rejected;
  } else if (allComplete) {
    buttonLabel = 'Edit';
    buttonClassName = styles.submitted;
  } else {
    buttonLabel = complete > 0 ? 'Continue' : 'Start';
    buttonClassName = styles._missing;
  }

  return (
    <div className={styles.root}>
      {
        dialogShow
        ? (
          <Dialog
            campaign={campaign}
            group={group}
            handle={handle}
          />
        )
        : null
      }

      <div className={styles.info}>
        <Icon name='share' />
        <div className={styles.content}>

          {
            group.reward.currency &&
            group.reward.amount && (
              <div className={styles.reward}>
                {`
                  ${currency.repr(group.reward.currency)}
                  ${group.reward.amount}
                  Reward
                `}
              </div>
            )
          }

          <div
            role='heading'
            aria-level='3'
            className={styles.descr}
            dangerouslySetInnerHTML={{
              __html: (
                group.descr
                ? group.descr
                : group.title.external
              ),
            }}
          />
        </div>
      </div>

      {
        total > 0 && (
          <div className={`${styles.comment} ${rejectedCount > 0 ? styles.error : styles.normal}`}>
            {rejectedCount > 0
              ? `${rejectedCount} rejected`
              : `${complete} of ${total} complete`
            }
          </div>
        )
      }

      {
        group.user.comment &&
        group.user.status === 'R' && (
          <div className={`${styles.comment} ${styles.error}`}>
            {group.user.comment}
          </div>
        )
      }

      <Link
        className={`
          ${styles.action}
          ${buttonClassName}
          ${group.user.enable ? '' : styles._blocked}
        `}
        aria-label={group.title.external}
        to={`?dialog=campaign+${campaign.id}+group+${group.id}`}>

        {buttonLabel}

      </Link>
    </div>
  );
};

export default ActivityGroup;
